<template>
  <div name="hrms32e" class="row personal-wrapper">
    <hrms-search-box-table v-show="indexDisp"
            v-model="searchIndex"
            :data="index"
            :nowLang="app.nowLang"
            :columns="columns[app.nowLang].index"
            :unLoadBool="true"
            :receivedStore="receivedHrms32eIndex"
            searchBoxAlias="request-subrogate"
            :addEvent="addEvent"
            :editEvent="editEvent"
            :cancelEvent="cancelEvent" />

    <div class="col-md-12 menu border-bottom-color-skin-dark-10" v-show="!indexDisp">
      <search-detail  :labels="labels[app.nowLang]"
                      :nowLang="app.nowLang"
                      :currentCodempid="codempid"
                      :searchDetail="searchDetail"
                      :descCodempid="app.currentUser.username[app.nowLang]"
                      :eventBtn="eventBtn"
                      :indexSelected="indexSelected"
                      :receivedHrms32eDetailTab1Create="receivedHrms32eDetailTab1Create"
                      :receivedHrms32eDetailTab2_6Create="receivedHrms32eDetailTab2_6Create"
                      />

      <div class="panelbutton-mb" :class="{ 'hidden' : pcDisp }">
        <div class="pers-header-btn">
          <div class="icon-menu fa fa-bars color-skin"></div>
          <div class="label-btn-pers color-skin" @click="toggleMenuMobile()"> Personal Data Menu </div>
        </div>

        <div class="show-menu" v-show="menuMbDisp || pcDisp">
          <!--Menu row 1-->
          <div class="rows clearfix">
            <div class="col-xs-4 pers-mb-btn" @click.stop="togglePage(1)">
              <img class="mb-btn-icon" src="../../assets/img/personal-data/1.svg">
              <div class="mb-btn-label">
                {{ labels[app.nowLang]['HRMS32EC1']['100'] }}
              </div>
            </div>
            <div class="col-xs-4 pers-mb-btn" @click.stop="togglePage(2)">
              <img class="mb-btn-icon" src="../../assets/img/personal-data/2.svg">
              <div class="mb-btn-label">
                {{ labels[app.nowLang]['HRMS32EC1']['110'] }}
              </div>
            </div>
            <div class="col-xs-4 pers-mb-btn" @click.stop="togglePage(3)">
              <img class="mb-btn-icon" src="../../assets/img/personal-data/6.svg">
              <div class="mb-btn-label">
                {{ labels[app.nowLang]['HRMS32EC1']['120'] }}
              </div>
            </div>
          </div>
          <!--Menu row 1-->
          <!--Menu row 2-->
          <div class="rows clearfix">
            <div class="col-xs-4 pers-mb-btn" @click.stop="togglePage(4)">
              <img class="mb-btn-icon" src="../../assets/img/personal-data/8.svg">
              <div class="mb-btn-label">
                {{ labels[app.nowLang]['HRMS32EC1']['130'] }}
              </div>
            </div>
            <div class="col-xs-4 pers-mb-btn" @click.stop="togglePage(5)">
              <img class="mb-btn-icon" src="../../assets/img/personal-data/12.svg">
              <div class="mb-btn-label">
                {{ labels[app.nowLang]['HRMS32EC1']['140'] }}
              </div>
            </div>
            <div class="col-xs-4 pers-mb-btn" @click.stop="togglePage(6)">
              <img class="mb-btn-icon" src="../../assets/img/personal-data/13.svg">
              <div class="mb-btn-label">
                {{ labels[app.nowLang]['HRMS32EC1']['150'] }}
              </div>
            </div>
          </div>
          <!--Menu row 2-->

        </div>
      </div>

      <div class="panelbutton" :class="{ 'hidden' : !pcDisp }">
        <!--Menu row 1-->
        <div class="row">
          <div class="col-sm-2 box-btn-pers">
            <div class="btn-pers-1 bg-hover-color-skin-light-5" :class="{ 'bg-color-skin active' : changeNameDataActive }" @click.stop="togglePage(1)">
              <div class="label-btn-pers" :class=" {'label-btn-pers-active' : changeNameDataActive} ">
                {{ labels[app.nowLang]['HRMS32EC1']['100'] }}
              </div>
            </div>
          </div>
          <div class="col-sm-2 box-btn-pers">
            <div class="btn-pers-2 bg-hover-color-skin-light-5" :class="{ 'bg-color-skin active' : personalDataActive }" @click.stop="togglePage(2)">
              <div class="label-btn-pers" :class=" {'label-btn-pers-active' : personalDataActive} ">
                {{ labels[app.nowLang]['HRMS32EC1']['110'] }}
              </div>
            </div>
          </div>
          <div class="col-sm-2 box-btn-pers">
            <div class="btn-pers-6 bg-hover-color-skin-light-5" :class="{ 'bg-color-skin active' : educationDataActive }" @click.stop="togglePage(3)">
              <div class="label-btn-pers" :class=" {'label-btn-pers-active' : educationDataActive} ">
                {{ labels[app.nowLang]['HRMS32EC1']['120'] }}
              </div>
            </div>
          </div>
          <div class="col-sm-2 box-btn-pers">
            <div class="btn-pers-8 bg-hover-color-skin-light-5" :class="{ 'bg-color-skin active' : childDataActive }" @click.stop="togglePage(4)">
              <div class="label-btn-pers" :class=" {'label-btn-pers-active' : childDataActive} ">
                {{ labels[app.nowLang]['HRMS32EC1']['130'] }}
              </div>
            </div>
          </div>
          <div class="col-sm-2 box-btn-pers">
            <div class="btn-pers-13 bg-hover-color-skin-light-5" :class="{ 'bg-color-skin active' : honorsDataActive }" @click.stop="togglePage(5)">
              <div class="label-btn-pers" :class=" {'label-btn-pers-active' : honorsDataActive} ">
                {{ labels[app.nowLang]['HRMS32EC1']['140'] }}
              </div>
            </div>
          </div>
          <div class="col-sm-2 box-btn-pers">
            <div class="btn-pers-12 bg-hover-color-skin-light-5" :class="{ 'bg-color-skin active' : trainingDataActive }" @click.stop="togglePage(6)">
              <div class="label-btn-pers" :class=" {'label-btn-pers-active' : trainingDataActive} ">
                {{ labels[app.nowLang]['HRMS32EC1']['150'] }}
              </div>
            </div>
          </div>
        </div>
        <!--Menu row 1-->
      </div>
    </div>
    <div class="col-md-12 clear-padding" v-show="(!menuMbDisp || pcDisp) && !indexDisp">
      <hrms32e-topic
          :nowLang="app.nowLang"
          :labels="labels[app.nowLang]"
          :detail="detailTab1"
          :pcDisp="pcDisp"
          :page="page"
          :subPage="subPage"
          :toggleMenuMobile="toggleMenuMobile"
          :onArrowLeft="onArrowLeft"
          :onArrowRight="onArrowRight"
          :onArrowSubLeft="onArrowSubLeft"
          :onArrowSubRight="onArrowSubRight"
          :searchDetail="searchDetail" />

      <v-touch @swipeleft="onSwipeLeft" @swiperight="onSwipeRight">
        <hrms32e-tab1 class="animate-option animated" :class="{ 'slideInLeft' : swipeRight, 'slideInRight' : swipeLeft }"
          v-show="changeNameDataActive"
          :nowLang="app.nowLang"
          :labels="labels[app.nowLang]"
          :labelsButton="app.button[app.nowLang]"
          :dropdowns="dropdowns"
          :detail="detailTab1"
          :pcDisp="pcDisp"
          :togglePage="togglePage"
          :indexSelected="indexSelected"
          :validateStaappr="validateStaappr"
          :postDetail1Save='postDetail1Save'
          :searchDetail="searchDetail"
          :searchIndex="searchIndex" />

        <hrms32e-tab2 class="animate-option animated" :class="{ 'slideInLeft' : swipeRight, 'slideInRight' : swipeLeft }"
          v-show="personalDataActive"
          :nowLang="app.nowLang"
          :allLang="app.allLang"
          :detail2Tab7Table="columns[app.nowLang].detail2Tab7Table"
          :labels="labels[app.nowLang]"
          :labelsButton="app.button[app.nowLang]"
          :deleteDocuments="deleteDocuments"
          :dropdowns="dropdowns"
          :detail="detailTab2"
          :pcDisp="pcDisp"
          :subPage="subPage"
          :togglePage="togglePage"
          :personalDataActive="personalDataActive"
          :indexSelected="indexSelected"
          :validateStaappr="validateStaappr"
          :postDetail2Tab1Save="postDetail2Tab1Save"
          :postDetail2Tab2Save="postDetail2Tab2Save"
          :postDetail2Tab3Save="postDetail2Tab3Save"
          :postDetail2Tab4Save="postDetail2Tab4Save"
          :postDetail2Tab5Save="postDetail2Tab5Save"
          :postDetail2Tab6Save="postDetail2Tab6Save"
          :postDetail2Tab7Save="postDetail2Tab7Save"
          :searchDetail="searchDetail"
          :searchIndex="searchIndex" />

        <hrms32e-tab3 class="animate-option animated" :class="{ 'slideInLeft' : swipeRight, 'slideInRight' : swipeLeft }"
          v-show="educationDataActive"
          :nowLang="app.nowLang"
          :detail3Table="columns[app.nowLang].detail3Table"
          :labels="labels[app.nowLang]"
          :labelsButton="app.button[app.nowLang]"
          :deleteEducation="deleteEducation"
          :dropdowns="dropdowns"
          :detail="detailTab3"
          :pcDisp="pcDisp"
          :togglePage="togglePage"
          :indexSelected="indexSelected"
          :validateStaappr="validateStaappr"
          :postDetail3Save="postDetail3Save"
          :searchDetail="searchDetail"
          :searchIndex="searchIndex" />

        <hrms32e-tab4 class="animate-option animated" :class="{ 'slideInLeft' : swipeRight, 'slideInRight' : swipeLeft }"
          v-show="childDataActive"
          :nowLang="app.nowLang"
          :detail4Table="columns[app.nowLang].detail4Table"
          :labels="labels[app.nowLang]"
          :labelsButton="app.button[app.nowLang]"
          :deleteChildData="deleteChildData"
          :dropdowns="dropdowns"
          :detail="detailTab4"
          :pcDisp="pcDisp"
          :togglePage="togglePage"
          :indexSelected="indexSelected"
          :validateStaappr="validateStaappr"
          :postDetail4Save="postDetail4Save"
          :searchDetail="searchDetail"
          :searchIndex="searchIndex" />

        <hrms32e-tab5 class="animate-option animated" :class="{ 'slideInLeft' : swipeRight, 'slideInRight' : swipeLeft }"
          v-show="honorsDataActive"
          :nowLang="app.nowLang"
          :labels="labels[app.nowLang]"
          :labelsButton="app.button[app.nowLang]"
          :arrTyprewd="dropdowns.typrewd"
          :detail="detailTab5"
          :pcDisp="pcDisp"
          :togglePage="togglePage"
          :indexSelected="indexSelected"
          :validateStaappr="validateStaappr"
          :postDetail5Save="postDetail5Save"
          :searchDetail="searchDetail"
          :searchIndex="searchIndex" />

        <hrms32e-tab6 class="animate-option animated" :class="{ 'slideInLeft' : swipeRight, 'slideInRight' : swipeLeft }"
          v-show="trainingDataActive"
          :nowLang="app.nowLang"
          :maxRowspanDetail6="maxRowspan.detail6TableMaxRowspan"
          :detail6Table="columns[app.nowLang].detail6Table"
          :labels="labels[app.nowLang]"
          :labelsButton="app.button[app.nowLang]"
          :deleteTrainingData="deleteTrainingData"
          :detail="detailTab6"
          :pcDisp="pcDisp"
          :togglePage="togglePage"
          :indexSelected="indexSelected"
          :validateStaappr="validateStaappr"
          :postDetail6Save="postDetail6Save"
          :searchDetail="searchDetail"
          :searchIndex="searchIndex" />
      </v-touch>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import * as types from 'store/modules/hrms32e/mutation-types'
import swal from 'sweetalert'
import moment from 'moment'
import searchDetail from 'components/hrms32e/searchDetail'
import hrms32eTopic from 'components/hrms32e/topic'
import hrms32eTab1 from 'components/hrms32e/tab1'
import hrms32eTab2 from 'components/hrms32e/tab2'
import hrms32eTab3 from 'components/hrms32e/tab3'
import hrms32eTab4 from 'components/hrms32e/tab4'
import hrms32eTab5 from 'components/hrms32e/tab5'
import hrms32eTab6 from 'components/hrms32e/tab6'
import { constLabels } from 'assets/js/constLabels.js'
import * as lovTypes from 'store/modules/hrmsLov/mutation-types'
import * as lovCodcompTypes from 'store/modules/hrmsLovCodcomp/mutation-types'

export default {
  name: 'hrms32e',
  data () {
    return {
      app: this.$root.$children[0],
      swipeRight: false,
      swipeLeft: false,
      changeNameDataActive: true,
      personalDataActive: false,
      educationDataActive: false,
      childDataActive: false,
      honorsDataActive: false,
      trainingDataActive: false,
      menuMbDisp: false,
      subTopic: true,
      page: 1,
      subPage: 1,
      indexDisp: true,
      eventBtn: '',
      searchIndex: {
        dtereqst: '01/' + moment().format('MM/YYYY'),
        dtereqen: moment().format('DD/MM/YYYY')
      },
      searchDetail: {
        dtereq: moment().format('DD/MM/YYYY'),
        codempid_query: this.$parent.$parent.$parent.currentUser.p_codempid
      }
    }
  },
  created () {
    this.receivedHrms32eDropdownsColumnsLabels()
    this.receivedHrms32eDropdowns2()
    // this.receivedHrms32eDetailIndex()
  },
  computed: {
    pcDisp () {
      return this.app.pcDisp
    },
    codempid () {
      let currentUser = this.app.currentUser
      return currentUser.p_codempid
    },
    validateStaappr () {
      return (this.indexSelected.staappr !== 'A' && this.indexSelected.staappr !== 'Y' && this.indexSelected.staappr !== 'N')
    },
    ...mapGetters({
      columns: types.GET_HRMS32E_COLUMNS,
      labels: types.GET_HRMS32E_LABELS,
      maxRowspan: types.GET_HRMS32E_MAX_ROWSPAN,
      dropdowns: types.GET_HRMS32E_DROPDOWNS,
      index: types.GET_HRMS32E_INDEX,
      indexSelected: types.GET_HRMS32E_INDEX_SELECTED,
      detailIndex: types.GET_HRMS32E_DETAIL_INDEX,
      detailTopic: types.GET_HRMS32E_DETAIL_TOPIC,
      detailTab1: types.GET_HRMS32E_DETAIL_TAB1,
      detailTab2: types.GET_HRMS32E_DETAIL_TAB2,
      detailTab3: types.GET_HRMS32E_DETAIL_TAB3,
      detailTab4: types.GET_HRMS32E_DETAIL_TAB4,
      detailTab5: types.GET_HRMS32E_DETAIL_TAB5,
      detailTab6: types.GET_HRMS32E_DETAIL_TAB6,
      lovCurrentDesc: lovTypes.GET_LOV_CURRENT_DESC,
      lovCodcompCurrentDesc: lovCodcompTypes.GET_LOV_CODCOMP_CURRENT_DESC
    })
  },
  methods: {
    addEvent () {
      let param = {
        numseq: '',
        typchg: '',
        codempid: ''
      }
      this.setIndexSelected(param)
      this.eventBtn = 'add'
      this.searchDetail.dtereq = moment().format('DD/MM/YYYY')
      this.searchDetail.codempid_query = ''
      this.receivedHrms32eDetailTab1Create()
      this.receivedHrms32eDetailTab2_6Create()
      this.receivedHrms32eDropdowns2()
      this.togglePage(1)
    },
    editEvent (param) {
      this.setIndexSelected(param)
      if (this.indexSelected.numseq) {
        // this.receivedHrms32eDetailIndex(searchParams)
        this.eventBtn = 'edit'
        this.descCodempidQuery = this.lovCurrentDesc('codempid', this.indexSelected.codempid_query)
        this.searchDetail.dtereq = this.indexSelected.dtereq
        this.searchDetail.codempid_query = this.indexSelected.codempid_query
        this.receivedHrms32eDetailTab1(this.indexSelected)
        this.receivedHrms32eDetailTab2_6(this.indexSelected)
        this.receivedHrms32eDropdowns2()
        this.togglePage(parseInt(this.indexSelected.typchg))
      }
    },
    cancelEvent (param) {
      this.setIndexSelected(param)
      if (this.indexSelected.staappr === 'P') {
        let sendParams = {
          p_codempid_query: this.indexSelected.codempid_query,
          p_dtereq: this.indexSelected.dtereq,
          p_numseq: this.indexSelected.numseq,
          p_typchg: this.indexSelected.typchg
        }
        this.postCancel({ cancelParams: sendParams, searchIndex: this.searchIndex })
      } else if (this.indexSelected.staappr === 'C') {
        swal({
          title: constLabels('warningTitle'),
          text: constLabels('HR1506'),
          confirmButtonText: constLabels('ok')
        })
      } else {
        swal({
          title: constLabels('warningTitle'),
          text: constLabels('HR1490'),
          confirmButtonText: constLabels('ok')
        })
      }
    },
    onArrowLeft () {
      this.swipeRight = false
      this.swipeLeft = false
      if (!this.pcDisp) {
        this.swipeLeft = true
      }
      this.triggerArrowButton(-1)
    },
    onArrowRight () {
      this.swipeRight = false
      this.swipeLeft = false
      if (!this.pcDisp) {
        this.swipeRight = true
      }
      this.triggerArrowButton(1)
    },
    onArrowSubLeft () {
      this.swipeRight = false
      this.swipeLeft = false
      if (!this.pcDisp) {
        this.swipeLeft = true
      }
      this.triggerSubArrowButton(-1)
    },
    onArrowSubRight () {
      this.swipeRight = false
      this.swipeLeft = false
      if (!this.pcDisp) {
        this.swipeRight = true
      }
      this.triggerSubArrowButton(1)
    },
    onSwipeRight () {
      if (!this.pcDisp) {
        this.swipeRight = false
        this.swipeLeft = false
        if (!this.pcDisp) {
          this.swipeRight = true
        }
        this.triggerSwipeButton(-1)
      }
    },
    onSwipeLeft () {
      if (!this.pcDisp) {
        this.swipeRight = false
        this.swipeLeft = false
        if (!this.pcDisp) {
          this.swipeLeft = true
        }
        this.triggerSwipeButton(1)
      }
    },
    triggerArrowButton (amountPage) {
      this.page = this.page + amountPage
      if (this.page <= 0) {
        this.page = 6
      }
      if (this.page > 6) {
        this.page = 1
      }
      if (this.page === 2) {
        this.subPage = 1
      }
      this.togglePage(this.page)
    },
    triggerSubArrowButton (amountPage) {
      this.subPage = this.subPage + amountPage
      if (this.subPage <= 0) {
        this.subPage = 7
      }
      if (this.subPage > 7) {
        this.subPage = 1
      }
      this.togglePage(this.page)
    },
    triggerSwipeButton (amountPage) {
      if (this.page !== 2 || this.subPage + amountPage <= 0 || this.subPage + amountPage > 7) {
        this.page = this.page + amountPage
        if (this.page === 2 && amountPage > 0) {
          this.subPage = 1
        }
        if (this.page === 2 && amountPage < 0) {
          this.subPage = 7
        }
      } else {
        this.subPage = this.subPage + amountPage
      }
      if (this.page <= 0) {
        this.page = 6
      }
      if (this.page > 6) {
        this.page = 1
      }
      if (this.subPage > 7) {
        this.subPage = 1
      }
      if (this.subPage <= 0) {
        this.subPage = 7
      }
      this.togglePage(this.page)
    },
    togglePage (page) {
      this.page = page
      this.indexDisp = false
      this.changeNameDataActive = false
      this.personalDataActive = false
      this.educationDataActive = false
      this.childDataActive = false
      this.honorsDataActive = false
      this.trainingDataActive = false
      this.menuMbDisp = false
      switch (page) {
        case 0:
          this.indexDisp = true
          break
        case 1:
          this.changeNameDataActive = true
          this.headerInfo = true
          break
        case 2:
          this.personalDataActive = true
          break
        case 3:
          this.educationDataActive = true
          break
        case 4:
          this.childDataActive = true
          break
        case 5:
          this.honorsDataActive = true
          break
        case 6:
          this.trainingDataActive = true
          break
        default:
          this.changeNameDataActive = true
          break
      }
    },
    toggleMenuMobile () {
      this.swipeLeft = false
      this.swipeRight = false
      this.menuMbDisp = !this.menuMbDisp
    },
    ...mapMutations({
      setIndexSelected: types.SET_HRMS32E_INDEX_SELECTED,
      deleteEducation: types.DELETE_HRMS32E_EDUCATION,
      deleteChildData: types.DELETE_HRMS32E_CHILD_DATA,
      deleteTrainingData: types.DELETE_HRMS32E_TRAINING_DATA,
      deleteDocuments: types.DELETE_HRMS32E_DOCUMENTS
    }),
    ...mapActions({
      receivedHrms32eDropdownsColumnsLabels: types.RECEIVED_HRMS32E_DROPDOWNS_COLUMNS_LABELS,
      receivedHrms32eDropdowns2: types.RECEIVED_HRMS32E_DROPDOWNS2,
      receivedHrms32eIndex: types.RECEIVED_HRMS32E_INDEX,
      receivedHrms32eDetailIndex: types.RECEIVED_HRMS32E_DETAIL_INDEX,
      receivedHrms32eDetailTopic: types.RECEIVED_HRMS32E_DETAIL_TOPIC,
      receivedHrms32eDetailTab1: types.RECEIVED_HRMS32E_DETAIL_TAB1,
      receivedHrms32eDetailTab2_6: types.RECEIVED_HRMS32E_DETAIL_TAB2_6,
      postDetail1Save: types.POST_HRMS32E_DETAIL1_SAVE,
      postDetail2Tab1Save: types.POST_HRMS32E_DETAIL2_TAB1_SAVE,
      postDetail2Tab2Save: types.POST_HRMS32E_DETAIL2_TAB2_SAVE,
      postDetail2Tab3Save: types.POST_HRMS32E_DETAIL2_TAB3_SAVE,
      postDetail2Tab4Save: types.POST_HRMS32E_DETAIL2_TAB4_SAVE,
      postDetail2Tab5Save: types.POST_HRMS32E_DETAIL2_TAB5_SAVE,
      postDetail2Tab6Save: types.POST_HRMS32E_DETAIL2_TAB6_SAVE,
      postDetail2Tab7Save: types.POST_HRMS32E_DETAIL2_TAB7_SAVE,
      postDetail3Save: types.POST_HRMS32E_DETAIL3_SAVE,
      postDetail4Save: types.POST_HRMS32E_DETAIL4_SAVE,
      postDetail5Save: types.POST_HRMS32E_DETAIL5_SAVE,
      postDetail6Save: types.POST_HRMS32E_DETAIL6_SAVE,
      postCancel: types.POST_HRMS32E_CANCEL,
      receivedHrms32eDetailTab1Create: types.RECEIVED_HRMS32E_DETAIL_TAB1_CREATE,
      receivedHrms32eDetailTab2_6Create: types.RECEIVED_HRMS32E_DETAIL_TAB2_6_CREATE
    })
  },
  components: {
    searchDetail,
    hrms32eTopic,
    hrms32eTab1,
    hrms32eTab2,
    hrms32eTab3,
    hrms32eTab4,
    hrms32eTab5,
    hrms32eTab6
  }
}
</script>

<style src="./style.scss" lang='scss'></style>



// WEBPACK FOOTER //
// component.vue?783b973a